export default "__VITE_ASSET__e8bce668__"